<template>
    <div class="fta" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>

        <div style="margin-top: -15px; margin-bottom: 5px; background-color: rgba(100, 116, 175, 0.0); padding: 20px 20px 10px 20px; color: #6d8d23; font-size: 25px; font-weight: bold;">
            {{ $t('workBalance.payroll.holidayCompensation') }}
        </div>


        <div v-if="sending" style="text-align:center; padding-top: 35px; padding-bottom: 35px;">
            <i class="fas fa-circle-notch fa-spin"></i> &nbsp; {{ $t('roster.comp.pleaseWait') }}<br/>
            {{ $t('roster.comp.selectOption') }}<br/>
            <br/>
            <small class="text-muted">{{ $t('roster.comp.windowCloses') }}</small>
        </div>


        <div v-if="!sending">
            <div style="width:600px; min-height: 30px; margin-left: 15px; margin-bottom: 15px; padding: 5px; text-align: left; color: #555; font-size: 13px;">
                <div v-on:click="ftaConfigOpen = !ftaConfigOpen;" style="cursor:pointer;">
                    {{ $t('roster.comp.hdcConfig') }} {{ ftaConfigOpen ? $t('global.ui.close').toLowerCase(): $t('global.ui.open').toLowerCase()}}
                    <i v-bind:class="[ftaConfigOpen ? 'fas fa-chevron-up': 'fas fa-chevron-down']"
                    style="cursor:pointer; margin-left: 5px"></i>
                </div>

                <div style="width:600px; min-height: 30px; padding-top: 10px; padding-bottom: 0px; text-align: left; color: #555; font-size: 13px; line-height:25px;" v-if="ftaConfigOpen && showBox == 0">
                    <strong>{{ $t('roster.comp.shiftsAfterMidnight') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configAllowDaysWithPastMidnight == false ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAllowDaysWithPastMidnight',!ftaConfigState.configAllowDaysWithPastMidnight)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ftaConfigState.configAllowDaysWithPastMidnight ? 'Blockieren FTA nicht' : 'Blockieren FTA'}}
                    </div><br/>

                    <strong>{{ $t('roster.comp.registrationPeriod') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configCreateTimeframe == 0 ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configCreateTimeframe',0)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.futureDays') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configCreateTimeframe == 1 ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configCreateTimeframe',1)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.entireMonth') }}
                    </div><br/>
                    
                    <strong>{{ $t('roster.comp.overTargetWorkTime') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configAllowOverPlanWorktime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAllowOverPlanWorktime',!ftaConfigState.configAllowOverPlanWorktime)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ftaConfigState.configAllowOverPlanWorktime ? $t('global.ui.yes') : $t('global.ui.no')}}
                    </div><br/>

                    <strong>{{ $t('roster.comp.monthCarryOver') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configAddPositivePrevMonthWorktime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAddPositivePrevMonthWorktime', !ftaConfigState.configAddPositivePrevMonthWorktime)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.positiveCarryOver') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configAddNegativePrevMonthWorktime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAddNegativePrevMonthWorktime', !ftaConfigState.configAddNegativePrevMonthWorktime)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.negativeCarryOver') }}
                    </div>
                    <br/>

                    <strong>{{ $t('roster.comp.maxTimePerHdc') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configUseOvertime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configUseOvertime', !ftaConfigState.configUseOvertime, false); SetFTAConfigState('configUseCustomMax', false);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.overtimeLimit') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configUseCustomMax == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configUseCustomMax', !ftaConfigState.configUseCustomMax, false); SetFTAConfigState('configUseOvertime', false);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.custom') }}
                    </div>
                    <br v-if="ftaConfigState.configUseCustomMax"/>
                    <br v-if="ftaConfigState.configUseCustomMax"/>
                    <strong v-if="ftaConfigState.configUseCustomMax">{{ $t('shift.template.workTime') }}: &nbsp;</strong>
                    <div style="width: 40%; display:inline-block; height: 16px;" v-if="ftaConfigState.configUseCustomMax">
                            <slider class="slider" :state="customMaxTimeSliderState" @callback="CustomMaxTimeSliderUpdate" />
                    </div>
                     <br/>
                    <strong>{{ $t('roster.comp.maxWorkWeek') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configUseWeekOvertime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configUseWeekOvertime', !ftaConfigState.configUseWeekOvertime);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.overtimeLimit') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configUseWeekOvertime == false ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configUseWeekOvertime', !ftaConfigState.configUseWeekOvertime);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.weekLimit') }}
                    </div>
                    <br/>
                    <br/>
                    <strong>{{ $t('roster.comp.maxDaysWeek') }}: &nbsp;</strong>
                    <div style="width: 40%; display:inline-block; height: 16px;">
                        
                       <slider class="slider" :state="maxWorkDaysSliderState" @callback="MaxWorkDaysSliderUpdate" />
                    </div>
                    <br/>
                    <br/>
                    <strong>{{ $t('roster.comp.additionalHdc') }}: &nbsp;</strong>
                    <div style="width: 40%; display:inline-block; height: 16px;">
                        
                       <slider class="slider" :state="additionalFTADaysSliderState" @callback="AdditionalDaysSliderUpdate" />
                    </div>
                    <br/>
                </div>

                <div style="width:600px; min-height: 30px; padding-top: 10px; padding-bottom: 0px; text-align: left; color: #555; font-size: 13px; line-height:25px;" v-if="ftaConfigOpen && (showBox == 2)">
                    <strong>{{ $t('roster.comp.timeFrame') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configSelectionTimeframe == 0 ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configSelectionTimeframe', 0);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.futureEntries') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configSelectionTimeframe == 1 ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configSelectionTimeframe', 1);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.entireMonth') }}
                    </div>
                    <br/>

                    <strong>{{ $t('roster.comp.overTarget') }} {{ $t('shift.template.workTime') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configAllowOverPlanWorktime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAllowOverPlanWorktime', !ftaConfigState.configAllowOverPlanWorktime);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ftaConfigState.configAllowOverPlanWorktime ? $t('global.ui.yes') : $t('global.ui.no')}}
                    </div>
                    <br/>

                    <strong>{{ $t('roster.comp.monthCarryOver') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configAddPositivePrevMonthWorktime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAddPositivePrevMonthWorktime', !ftaConfigState.configAddPositivePrevMonthWorktime)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.positiveCarryOver') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configAddNegativePrevMonthWorktime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configAddNegativePrevMonthWorktime', !ftaConfigState.configAddNegativePrevMonthWorktime)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.negativeCarryOver') }}
                    </div>
                    <br/>
                    
                    <strong>{{ $t('roster.comp.maxTimePerHdc') }}: &nbsp;</strong>
                     <div v-bind:class="[ ftaConfigState.configUseOvertime == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configUseOvertime', !ftaConfigState.configUseOvertime, false); SetFTAConfigState('configUseCustomMax', false)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.overtimeLimit') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configUseCustomMax == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configUseCustomMax', !ftaConfigState.configUseCustomMax, false); SetFTAConfigState('configUseOvertime', false)" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.custom') }}
                    </div>
                    <br v-if="ftaConfigState.configUseCustomMax"/>
                    <br v-if="ftaConfigState.configUseCustomMax"/>
                    <strong v-if="ftaConfigState.configUseCustomMax">{{ $t('shift.template.workTime') }}: &nbsp;</strong>
                    <div style="width: 40%; display:inline-block; height: 16px;" v-if="ftaConfigState.configUseCustomMax">
                            <slider class="slider" :state="customMaxTimeSliderState" @callback="CustomMaxTimeSliderUpdate" />
                    </div>
                </div>



                <div style="width:600px; min-height: 30px; padding-top: 10px; padding-bottom: 0px; text-align: left; color: #555; font-size: 13px; line-height:25px;" v-if="ftaConfigOpen && (showBox == 1)">
                    <strong>{{ $t('roster.comp.timeFrame') }}: &nbsp;</strong>
                    <div v-bind:class="[ ftaConfigState.configSelectionTimeframe == 0 ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configSelectionTimeframe', 0);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.futureEntries') }}
                    </div>
                    <div v-bind:class="[ ftaConfigState.configSelectionTimeframe == 1 ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="SetFTAConfigState('configSelectionTimeframe', 1);" style="cursor:pointer;">
                        <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{ $t('roster.comp.entireMonth') }}
                    </div><br/>
                    
                    
                </div>

            </div>

            




            <div v-bind:class="[(showBox == 0) ? 'boxPanelLeftSelected' : 'boxPanelLeftNotSelected']" v-on:click="SwitchShowBox(0)" style="cursor:pointer;">
                {{ $t('roster.comp.enterHdc') }}
            </div>
            <div v-bind:class="[(showBox == 2) ? 'boxPanelMiddleSelected' : 'boxPanelMiddleNotSelected']" v-on:click="SwitchShowBox(2)" style="cursor:pointer;">
                {{ $t('roster.comp.editHdc') }}
            </div>
            <div v-bind:class="[(showBox == 1) ? 'boxPanelRightSelected' : 'boxPanelRightNotSelected']" v-on:click="SwitchShowBox(1)" style="cursor:pointer;">
                {{ $t('roster.comp.deleteHdc') }}
            </div>
            <div class="panelContent">






                <div  v-if="showBox == 1 && countToDelete == 0">
                    <div style="width: 100%; border:solid darkgray 1px; overflow:hidden; border-radius: 10px; padding:10px; margin-top: 10px; margin-bottom:10px; background-color: #fafafa; text-align: center;">
                        {{ $t('roster.comp.noHdcFound') }}
                    </div>
                </div>
                <div v-for="(row, i) in deletableFTAs" :key="i" v-if="row.deleteFTA && showBox == 1 && countToDelete > 0 && row.items > 0">
                    <div style="width: 100%; border:solid darkgray 1px; overflow:hidden; border-radius: 10px; padding:10px; margin-top: 10px; margin-bottom:10px; background-color: #fafafa;">
                        <div v-if="$parent.employeeMap[row.employeeId] != null" style="line-height: 30px; height:30px; cursor: pointer;" v-on:click="OpenEmployee(row.id)">
                            <div style="float:left; height: 25px; line-height:25px; width: 368px;cursor: pointer;">
                                <img class="picture" v-bind:src="$parent.employeeMap[row.employeeId] !== null ? $parent.employeeMap[row.employeeId].pictureNoBackground : '../img/default.jpg'" style="cursor: pointer;"/>
                                <strong  style="cursor: pointer; font-size: 16px;">{{ $parent.employeeMap[row.employeeId].lastName }} {{ $parent.employeeMap[row.employeeId].firstName }} </strong>
                            </div>

                            <div style="float:left; height: 25px; line-height:25px; width: 245px; cursor: pointer;">
                                <small  style="cursor: pointer; font-size: 12px; cursor: pointer;">{{ row.items }} {{ row.itemLabel }}</small>
                            </div>


                            <div style="float:right; height: 25px; line-height:25px; width: 25px; cursor: pointer;">
                                <i class="fas fa-chevron-circle-up updown" style="cursor: pointer;" v-if="row.opened"></i>
                                <i class="fas fa-chevron-circle-down updown" style="cursor: pointer;" v-if="!row.opened"></i>
                            </div>

                            <div style="float:right; height: 25px; line-height:25px; width: 25px; margin-right:15px; cursor: pointer;" v-on:click="ToggleSelected(row.id);OpenEmployee(row.id)">
                                <i class="fas fa-check-circle updown" style="cursor: pointer;" v-if="row.selectedForFTA"></i>
                                <i class="fas fa-circle updown" style="cursor: pointer;" v-if="!row.selectedForFTA"></i>
                            </div>
                        </div>

                        <div v-if="row.opened" style="float:left; padding-top: 10px; font-size: 14px; width:710px; border:0px solid black; padding-left: 5px; min-height: 25px;">
                            <div v-for="(row2,j) in row.map" :key="j" >
                                <strong>{{ row2.dates.fromDate.format('DD.MM.YYYY HH:mm') }} &nbsp;-&nbsp; {{ row2.dates.toDate.format('DD.MM.YYYY HH:mm') }}</strong> &nbsp;<small class="text-muted">&bull;</small>&nbsp; <small>{{ (row2.workValue/60).toFixed(2) }} h</small>
                            </div>
                        </div>
                    </div>
                </div>




                
                <div  v-if="showBox == 0 && countToCreate == 0">
                    <div style="width: 100%; border:solid darkgray 1px; overflow:hidden; border-radius: 10px; padding:10px; margin-top: 10px; margin-bottom:10px; background-color: #fafafa; text-align: center;">
                        {{ $t('roster.comp.cantEnterHdc') }}
                    </div>
                </div>
                <!--<div v-for="(row, i) in x" :key="i" v-if="row.doFTA && showBox == 0 && countToCreate > 0">-->
                <div v-for="(row, i) in creatableFTAs" :key="i" v-if="row.doFTA && showBox == 0 && countToCreate > 0">

                    <div style="width: 100%; border:solid darkgray 1px; overflow:hidden; border-radius: 10px; padding:10px; margin-top: 10px; margin-bottom:10px; background-color: #fafafa;">

                        

                        <div v-if="$parent.employeeMap[row.employeeId] != null" style="line-height: 30px; height:30px; cursor: pointer;" v-on:click="OpenEmployee(row.id)">
                            <div style="float:left; height: 25px; line-height:25px; width: 368px;cursor: pointer;">
                                <img class="picture" v-bind:src="$parent.employeeMap[row.employeeId] !== null ? $parent.employeeMap[row.employeeId].pictureNoBackground : '../img/default.jpg'" style="cursor: pointer;"/>
                                <strong  style="cursor: pointer; font-size: 16px;">{{ $parent.employeeMap[row.employeeId].lastName }} {{ $parent.employeeMap[row.employeeId].firstName }}</strong>
                            </div>

                            <div style="float:left; height: 25px; line-height:25px; width: 165px; cursor: pointer;">
                                <small  style="cursor: pointer; font-size: 12px; cursor: pointer;">{{ row.ftsum.toFixed(2) }} h</small>
                            </div>
                            <div style="float:left; height: 25px; line-height:25px; width: 80px; cursor: pointer;">
                                <small  style="cursor: pointer; font-size: 12px; cursor: pointer;" v-bind:class="[(row.remainingEqualize <= 0) ? 'text-success' : 'text-danger']">{{ (row.remainingEqualize/60).toFixed(2) }} h</small>
                            </div>


                            <div style="float:right; height: 25px; line-height:25px; width: 25px; cursor: pointer;">
                                <i class="fas fa-chevron-circle-up updown" style="cursor: pointer;" v-if="row.opened"></i>
                                <i class="fas fa-chevron-circle-down updown" style="cursor: pointer;" v-if="!row.opened"></i>
                            </div>

                            <div style="float:right; height: 25px; line-height:25px; width: 25px; margin-right:15px; cursor: pointer;" v-on:click="ToggleSelected(row.id);OpenEmployee(row.id)">
                                <i class="fas fa-check-circle updown" style="cursor: pointer;" v-if="row.selectedForFTA"></i>
                                <i class="fas fa-circle updown" style="cursor: pointer;" v-if="!row.selectedForFTA"></i>
                            </div>
                        </div>


                        <div v-if="row.opened" style="float:left; padding-top: 10px; font-size: 14px; width:361px; border:0px solid black; padding-left: 5px; min-height: 95px;">

                            <strong>{{ $t('roster.comp.sumWorkTime') }}: </strong> &nbsp;<small class="">{{ (row.sumWorktime).toFixed(2) }} h</small><br/>

                            <strong>{{ $t('roster.comp.holidayHours') }}: </strong> &nbsp;<small class="text-danger">{{ row.ftsum.toFixed(2) }} h</small><br/>
                            <!--<strong>Feiertagsausgleich: </strong> &nbsp;<small>{{ (row.ftausgleich).toFixed(2) }} h</small><br/>-->
                            <strong>{{ $t('roster.comp.workTimePerWeek') }}: </strong> &nbsp;<small>{{ (row.minutesPerWeek / 60.0).toFixed(2) }} h</small><br/>
                            <strong>{{ $t('roster.comp.averageDailyWork') }}: </strong> &nbsp;<small>{{ (row.minutesPerDay / 60.0).toFixed(2) }} h</small><br/>
                            <strong>{{ $t('roster.comp.hdcDesired') }}: </strong> &nbsp;<small class="text-primary">{{ (row.maxEqualize).toFixed(2) }} h</small><br/>
                            <strong>{{ $t('roster.comp.hdcAfterBalance') }}: </strong> &nbsp;<small v-bind:class="[(row.remainingEqualize <= 0) ? 'text-success' : 'text-danger']">{{ (row.remainingEqualize/60).toFixed(2) }} h</small><br/>
                        </div>












                        <div v-if="row.opened" style="float:right; padding-top: 10px; font-size: 14px; width:344px; border:0px solid black; padding-left: 5px; min-height: 95px;">
                            <div v-for="(row2,j) in row.dayMap" :key="j" v-if="row2.useFTA > 0">
                                <strong>{{ row2.formatAUT }}</strong> &nbsp;<small class="text-muted">&bull;</small>&nbsp; <small>{{ (row2.useFTA/60.0).toFixed(2) }} h</small>
                            </div>
                        </div>
                    </div>

                </div>

                <div  v-if="showBox == 2 && countToEqualize == 0">
                    <div style="width: 100%; border:solid darkgray 1px; overflow:hidden; border-radius: 10px; padding:10px; margin-top: 10px; margin-bottom:10px; background-color: #fafafa; text-align: center;">
                        {{ $t('roster.comp.noHdcBalanceFound') }}
                    </div>
                </div>
                <!--<div v-for="(row, i) in x" :key="i" v-if="row.doFTA && showBox == 0 && countToCreate > 0">-->
                <div v-for="(row, i) in equalizableFTAs" :key="i" v-if="row.equalizeFTA && showBox == 2 && countToEqualize > 0">

                    <div style="width: 100%; border:solid darkgray 1px; overflow:hidden; border-radius: 10px; padding:10px; margin-top: 10px; margin-bottom:10px; background-color: #fafafa;">

                        

                        <div v-if="$parent.employeeMap[row.employeeId] != null" style="line-height: 30px; height:30px; cursor: pointer;" v-on:click="OpenEmployee(row.id)">
                            <div style="float:left; height: 25px; line-height:25px; width: 368px;cursor: pointer;">
                                <img class="picture" v-bind:src="$parent.employeeMap[row.employeeId] !== null ? $parent.employeeMap[row.employeeId].pictureNoBackground : '../img/default.jpg'" style="cursor: pointer;"/>
                                <strong  style="cursor: pointer; font-size: 16px;">{{ $parent.employeeMap[row.employeeId].lastName }} {{ $parent.employeeMap[row.employeeId].firstName }}</strong>
                            </div>

                            <div style="float:left; height: 25px; line-height:25px; width: 165px; cursor: pointer;">
                                <small  style="cursor: pointer; font-size: 12px; cursor: pointer;">{{ row.ftsum.toFixed(2) }} h</small>
                            </div>
                            <div style="float:left; height: 25px; line-height:25px; width: 80px; cursor: pointer;">
                                <small  style="cursor: pointer; font-size: 12px; cursor: pointer;" v-bind:class="[(row.remainingEqualize <= 0) ? 'text-success' : 'text-danger']">{{ (row.remainingEqualize/60).toFixed(2) }} h</small>
                            </div>


                            <div style="float:right; height: 25px; line-height:25px; width: 25px; cursor: pointer;">
                                <i class="fas fa-chevron-circle-up updown" style="cursor: pointer;" v-if="row.opened"></i>
                                <i class="fas fa-chevron-circle-down updown" style="cursor: pointer;" v-if="!row.opened"></i>
                            </div>

                            <div style="float:right; height: 25px; line-height:25px; width: 25px; margin-right:15px; cursor: pointer;" v-on:click="ToggleSelected(row.id);OpenEmployee(row.id)">
                                <i class="fas fa-check-circle updown" style="cursor: pointer;" v-if="row.selectedForFTA"></i>
                                <i class="fas fa-circle updown" style="cursor: pointer;" v-if="!row.selectedForFTA"></i>
                            </div>
                        </div>


                        <div v-if="row.opened" style="float:left; padding-top: 10px; font-size: 14px; width:361px; border:0px solid black; padding-left: 5px; min-height: 95px;">

                            <strong>{{ $t('roster.comp.sumWorkTime') }}: </strong> &nbsp;<small class="">{{ (row.sumWorktime).toFixed(2) }} h</small><br/>

                            <strong>{{ $t('roster.comp.holidayHours') }}: </strong> &nbsp;<small class="text-danger">{{ row.ftsum.toFixed(2) }} h</small><br/>
                            
                            <strong>{{ $t('roster.comp.hdcDesired') }}: </strong> &nbsp;<small class="text-primary">{{ (row.maxEqualize).toFixed(2) }} h</small><br/>
                            
                            <strong>{{ $t('roster.comp.hdcAfterBalance') }}: </strong> &nbsp;<small v-bind:class="[(row.remainingEqualize <= 0) ? 'text-success' : 'text-danger']">{{ (row.remainingEqualize/60).toFixed(2) }} h</small><br/>
                        </div>

                        <div v-if="row.opened" style="float:left; padding-top: 10px; font-size: 14px; width:710px; border:0px solid black; padding-left: 5px; min-height: 25px;">
                            <div v-for="(row2,j) in row.map" :key="j" >
                                <strong>{{ row2.dates.fromDate.format('DD.MM.YYYY HH:mm') }} &nbsp;-&nbsp; {{ row2.dates.toDate.format('DD.MM.YYYY HH:mm') }}</strong> &nbsp;
                                <small class="text-muted">&bull;</small>&nbsp; 
                                <small>{{ (row2.workValue/60).toFixed(2) }} h</small>&nbsp;
                                <small class="text-muted">&bull;</small>&nbsp; 
                                <small v-bind:class="[(row2.newWorkValue > row2.workValue > 0) ? 'text-success' : (row2.newWorkValue < row2.workValue > 0) ? 'text-danger': '']">{{ (row2.newWorkValue/60).toFixed(2) }} h</small>&nbsp;
                            </div>
                        </div>
                    </div>

                </div>

            </div>


            <div style="overflow: hidden; height: 60px; padding-top: 20px; text-align: center;">

                <buttonc :label="$t('global.ui.cancel')" type="red" style="width: 200px; margin: 5;" @click="Close()" />

                <buttonc :label="$t('roster.comp.enterSelectedHdc')" type="green" style="width: 200px; margin: 0;" @click="CreateSelected()" v-if="showBox==0 && countToCreate > 0"/>
                <buttonc :label="$t('roster.comp.deleteSelectedHdc')" type="green" style="width: 200px; margin: 0;" @click="DeleteSelected()" v-if="showBox==1 && countToDelete > 0"/>
                <buttonc :label="$t('roster.comp.editSelectedHdc')" type="green" style="width: 200px; margin: 0;" @click="UpdateSelected()" v-if="showBox==2 && countToEqualize > 0"/>
            </div>
        </div>


    </div>
</template>


<script>
    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'fta',
        components: {
        },
        data(){
            return{
                toggled: false,
                elRelative: null,

                posx: 0,
                posy: 0,

                creatableFTAs: null,
                deletableFTAs: null,
                equalizableFTAs: null,

                showBox: 0,

                ftaConfigOpen: false,

                sending: false,

                sendingCreateSuccess: true,
                sendingDeleteSuccess: true,
                sendingHelper: 0,
                sentHelper: 0,

                countToCreate: 0,
                countToDelete: 0,
                countToEqualize: 0,
                spareTimeMaps: {},
                weekWorkTimeMaps: {},
            }
        },
        created () {
            
        },
        destroyed(){
        },
        computed: {
            ...mapGetters(['storeId', 'rosterFromTo', 'employeeMap', 'ftaConfigState']),
            additionalFTADaysSliderState() {
                return {
                        hideMin: true,
                        hideMax: true,
                        min: 0, 
                        max: 30, 
                        value: this.ftaConfigState.additionalFTADays, 
                        step: 1,
                        inputControl: false,
                        sliderInput: (x) => { return x},
                    }
            }, 
            maxWorkDaysSliderState() {
                return {
                        hideMin: true,
                        hideMax: true,
                        min: 0, 
                        max: 7, 
                        value: this.ftaConfigState.maxWorkDays, 
                        step: 1,
                        inputControl: false,
                        sliderInput: (x) => { return x},
                    }
            }, 
            customMaxTimeSliderState() {
                return {
                        hideMin: true,
                        hideMax: true,
                        min: 0.25, 
                        max: 24, 
                        value: this.ftaConfigState.customMaxTime, 
                        step: 0.25,
                        inputControl: false,
                        sliderInput: (x) => { return x},
                    }
            } 
        },
        methods: {
            SetFTAConfigState(key, value, calculate = true){
                this.$store.commit("setFtaConfigStateValue", {key: key, value: value});
                if(calculate){
                    this.Calculate(false);
                }
                
            },
            AdditionalDaysSliderUpdate(val, object){
                this.$store.commit("setFtaConfigStateValue", {key: 'additionalFTADays', value: val});
                this.Calculate(false)
            },
            MaxWorkDaysSliderUpdate(val, object){
                this.$store.commit("setFtaConfigStateValue", {key: 'maxWorkDays', value: val});
                this.Calculate(false)
            },
            CustomMaxTimeSliderUpdate(val, object){
                this.$store.commit("setFtaConfigStateValue", {key: 'customMaxTime', value: val});
                this.Calculate(false)
            },
            CreateSelected(){
                let view = this;
                this.sending = true;

                let requests = [];
                for(let i in this.creatableFTAs){
                    let row = this.creatableFTAs[i];
                    if(row.doFTA && row.selectedForFTA){
                        for(let j in row.dayMap){
                            let row2 = row.dayMap[j];
                            if(row2.useFTA > 0){
                                requests.push({
                                    storeId: view.$store.state.storeId,
                                    from: view.$helpers.convertDateString(row2.from),
                                    to: view.$helpers.convertDateString(row2.to),
                                    exclusive: true,
                                    approved: true,
                                    factor: 1,
                                    employeeId: row.employeeId,
                                    spotId: null,
                                    comment: 'FTA Automatik',
                                    state: 1,
                                    type: 3,
                                    workValue: row2.useFTA,
                                    overrideContract: true,
                                    alwaysWork: true,
                                });
                            }
                        }
                    }
                }


                let url = '/api/sec/employeepreference/multi';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference/multi');
                let payload = {
                    requests: requests,
                };
                this.axios({
                    method: 'post',
                    headers: { 'AUTHORIZATION': "bearer "+this.$store.state.jwt },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('roster.comp.absencesCreated'));
                    view.sending = false;
                    view.$helpers.GetEmployeePreferenceMap(true);
                    view.Close();
                    view.$forceUpdate();
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.ui.createFailed'), view.$t('roster.comp.createAbsencesError'));
                    view.sending = false;
                    view.Close();
                    view.sentHelper++;
                })
            },

            DeleteSelected(){
                let view = this;
                this.sending = true;

                let ids = [];
                for(let i in this.deletableFTAs){
                    let row = this.deletableFTAs[i];
                    if(row.deleteFTA && row.selectedForFTA){
                        for(let j in row.map){
                            ids.push(row.map[j].item.id);
                        }
                    }
                }
                let payload = {ids: ids}

                let url = '/api/sec/employeepreference/any/delete';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference/any/delete');
                this.axios({
                    method: 'post',
                    headers: { 'AUTHORIZATION': "bearer "+view.$store.state.jwt },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success(view.$t('shift.template.deleted'), view.$t('roster.comp.absenceDeleted'));
                    view.sending = false;
                    view.$helpers.GetEmployeePreferenceMap(true);
                    view.Close();
                    view.$forceUpdate();
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.ui.deleteFailed'), this.$t('roster.comp.deleteAbsenceError'));
                    view.sending = false;
                    view.Close();
                })
            },
            UpdateSelected(){
                let view = this;
                this.sending = true;

                let requests = [];
                for(let i in this.equalizableFTAs){
                    let row = this.equalizableFTAs[i];
                    if(row.equalizeFTA && row.selectedForFTA){
                        for(let j in row.map){
                            let entry = row.map[j];
                            if(entry.newWorkValue != entry.workValue){
                                requests.push({id: entry.item.id, updateFields:["workValue"], workValue: entry.newWorkValue})
                            }
                            
                        }
                    }
                }
                
                if(requests.length > 0){
                    let url = '/api/sec/employeepreference/multi';
                    let params = {
                        storeId: this.$store.state.storeId
                    }
                    let payload = {
                        requests: requests,
                    };
                    this.axios({
                        method: 'put',
                        headers: { 'AUTHORIZATION': "bearer "+view.$store.state.jwt },
                        url: url,
                        params: params,
                        data: payload
                    }).then(response => {
                        view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('roster.comp.absencesEdited'));
                        view.sending = false;
                        view.$helpers.GetEmployeePreferenceMap(true);
                        view.Close();
                        view.$forceUpdate();
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('roster.comp.editAbsencesError'));
                        view.sending = false;
                        view.Close();
                    })
                } else {
                    view.sending = false;
                    view.Close();
                }
                
            },
            SwitchShowBox(id){
                this.showBox = id;
            },
            OpenEmployee(id){
                if(this.showBox == 0){
                    for(let i in this.creatableFTAs){
                        if(this.creatableFTAs[i].id == id){
                            this.creatableFTAs[i].opened = !this.creatableFTAs[i].opened;
                        }
                    }
                } else if(this.showBox == 1){
                    for(let i in this.deletableFTAs){
                        if(this.deletableFTAs[i].id == id){
                            this.deletableFTAs[i].opened = !this.deletableFTAs[i].opened;
                        }
                    }
                } else if(this.showBox == 2){
                    for(let i in this.equalizableFTAs){
                        if(this.equalizableFTAs[i].id == id){
                            this.equalizableFTAs[i].opened = !this.equalizableFTAs[i].opened;
                        }
                    }
                }
            },
            ToggleSelected(id){
                if(this.showBox == 0){
                    for(let i in this.creatableFTAs){
                        let obj = this.creatableFTAs[i];
                        if(obj.id == id){
                            obj.selectedForFTA = !obj.selectedForFTA;
                        }
                    }
                } else if(this.showBox == 1){
                    for(let i in this.deletableFTAs){
                        let obj = this.deletableFTAs[i];
                        if(obj.id == id){
                            obj.selectedForFTA = !obj.selectedForFTA;
                        }
                    }
                } else if(this.showBox == 2){
                    for(let i in this.equalizableFTAs){
                        let obj = this.equalizableFTAs[i];
                        if(obj.id == id){
                            obj.selectedForFTA = !obj.selectedForFTA;
                        }
                    }
                }
                this.Calculate(true);
            },
            Init(){
                this.toggled = true;
                this.Reposition();
                this.CalculateSpareTimeMaps();
                this.CalculateWeekWorkTimeMaps();
                this.Calculate(false);
            },
            CalculateWeekWorkTimeMaps() {
                this.weekWorkTimeMaps = this.$rosterhelper.calculateWeekWorkMap(this.$parent.employeeDateCombinedShiftMap,
                                                                                this.$parent.employeePreferenceAvailabilityMap,
                                                                                this.$parent.planShiftMomentMap,
                                                                                this.$parent.actualShiftMomentMap,
                                                                                this.$parent.actualBreakShiftIdMap,
                                                                                this.$parent.actualBreakMomentMap,
                                                                                this.$parent.employeePreferenceMomentMap,
                                                                                this.$parent.employeeIdContractMap,
                                                                                this.$parent.employeeContractMomentMap,
                                                                                this.$parent.storeSettings,
                                                                                this.$parent.employeeMap,
                                                                                this.$parent.employeeAvgWorktimeMap, 
                                                                                this.$helpers)
            },
            CalculateSpareTimeMaps(){
                this.spareTimeMaps = {};
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.$parent.rosterFromTo.from);
                Object.values(this.$parent.employeeMap).forEach(employee => {
                    let contracts = Object.values(this.$parent.currentMonthEmployeeContractMap).filter(item => item.employeeId == employee.id);
                    let spareTimeMap = null;
                    if(contracts.length > 0){
                        let contract = contracts[0];
                        let spareDays = 1;
                        let spareTime = 36*60;
                        let underage = false;
                        if(employee.dob){
                            let underageStats = this.$rosterhelper.calculateUnderageStats(rosterFrom, this.$helpers.getMomentFromStringTZ(employee.dob));
                            underage = underageStats.underage;
                        }
                        if (contract.collectiveContractId != null) {
                            let allowedContract = this.$parent.allowedContractMap[contract.collectiveContractId];
                            let ccontract = this.$parent.collectiveContractMap[allowedContract.collectiveContractId];
                        
                            spareDays = ccontract.weekSpareDaysMin;
                            spareTime = ccontract.weekSpareTimeMin;
                            
                        }
                        if (underage) {
                            spareDays = 2;
                            spareTime = 48*60;
                        }
                        spareTimeMap = this.$rosterhelper.determineSpareTimeRanges(employee, 
                                                                this.$parent.employeeDateCombinedShiftMap, 
                                                                this.$parent.employeePreferenceAvailabilityMap, 
                                                                this.$parent.planShiftMomentMap, 
                                                                this.$parent.actualShiftMomentMap, 
                                                                this.$parent.employeePreferenceMomentMap, 
                                                                this.$parent.rosterFromTo, spareDays, spareTime,
                                                                this.$parent.storeSettings,
                                                                true)
                        /*console.log(employee.firstName+" "+employee.lastName);
                        for(let key in spareTimeMap){
                            console.log(key+" "+spareTimeMap[key].from.format()+" - "+spareTimeMap[key].to.format())
                        }
                        console.log("######") */
                        this.spareTimeMaps[employee.id] = spareTimeMap;
                    }
                })
                
            },
            Calculate(recalc){
                this.countToDelete = 0;
                this.countToCreate = 0;
                
                 //Create the template Map, so we get the dates which are the keys of the map
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.$store.state.rosterFromTo.from);
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.$store.state.rosterFromTo.to);
                let rosterMonth = rosterFrom.clone().add(7,'days');
                    
                let mapTemplate = {};
                let rosterFromClone = rosterFrom.clone();
                while(rosterTo.diff(rosterFromClone) > 0) {
                    let dateString = rosterFromClone.format("YYYY-MM-DD");
                    mapTemplate[dateString] = {};
                    rosterFromClone.add(1,'days');
                }
                /*
                let dateString = rosterFrom.format("YYYY-MM-DD");
                mapTemplate[dateString] = {};
                */

                let today = this.$helpers.getMomentTZ();


                let tempX = this.creatableFTAs;
                let tempY = this.deletableFTAs;
                let tempZ = this.equalizableFTAs;
                this.creatableFTAs = [];         
                this.deletableFTAs = [];
                this.equalizableFTAs = [];  
                       
                for(let id in this.$parent.employeePlannedActual){
                    
                    /* ************************* */
                    /* ************************* */
                    /* BLOCK FOR DELETION */
                    this.calculateDeletable(id, this.deletableFTAs, tempY, recalc, today, rosterMonth);
                    this.countToDelete = 0;
                    this.deletableFTAs.forEach(item => {
                        
                        this.countToDelete += item.items;
                        
                    })
                    this.deletableFTAs.sort((a,b)=> {
                        if(this.$parent.employeeMap[a.employeeId] &&this.$parent.employeeMap[b.employeeId]){
                            let labelA = this.$parent.employeeMap[a.employeeId].lastName +" "+this.$parent.employeeMap[a.employeeId].firstName;
                            let labelB =  this.$parent.employeeMap[b.employeeId].lastName +" "+this.$parent.employeeMap[b.employeeId].firstName;
                            if(labelA.toLowerCase() < labelB.toLowerCase()){
                                return -1;
                            } else if (labelA.toLowerCase() < labelB.toLowerCase()){
                                return 1;
                            }
                        }
                        
                        return 0;
                    })      
                    /* BLOCK FOR DELETION END */

                    /* BLOCK FOR CREATION */
                    this.calculateCreatable(id, this.creatableFTAs, tempX, recalc, today, rosterFrom, rosterTo, rosterMonth, mapTemplate);
                    this.countToCreate = 0;
                    this.creatableFTAs.forEach(item => {
                        Object.values(item.dayMap).forEach(day => {
                            if(day.useFTA > 0){
                                this.countToCreate++;
                            }
                        })
                        
                        
                    })
                    this.creatableFTAs.sort((a,b)=> {
                        if(this.$parent.employeeMap[a.employeeId] &&this.$parent.employeeMap[b.employeeId]){
                            let labelA = this.$parent.employeeMap[a.employeeId].lastName +" "+this.$parent.employeeMap[a.employeeId].firstName;
                            let labelB =  this.$parent.employeeMap[b.employeeId].lastName +" "+this.$parent.employeeMap[b.employeeId].firstName;
                            if(labelA.toLowerCase() < labelB.toLowerCase()){
                                return -1;
                            } else if (labelA.toLowerCase() < labelB.toLowerCase()){
                                return 1;
                            }
                        }
                        
                        return 0;
                    })     
                    /* BLOCK FOR CREATION END */
                    
                    /* BLOCK FOR EQUALIZE */
                    this.calculateEqualizable(id, this.equalizableFTAs, tempZ, recalc, today, rosterMonth);
                    this.countToEqualize = 0;
                    this.equalizableFTAs.forEach(item => {
                        
                        this.countToEqualize += item.items;
                        
                    })
                    this.equalizableFTAs.sort((a,b)=> {
                        if(this.$parent.employeeMap[a.employeeId] &&this.$parent.employeeMap[b.employeeId]){
                            let labelA = this.$parent.employeeMap[a.employeeId].lastName +" "+this.$parent.employeeMap[a.employeeId].firstName;
                            let labelB =  this.$parent.employeeMap[b.employeeId].lastName +" "+this.$parent.employeeMap[b.employeeId].firstName;
                            if(labelA.toLowerCase() < labelB.toLowerCase()){
                                return -1;
                            } else if (labelA.toLowerCase() < labelB.toLowerCase()){
                                return 1;
                            }
                        }
                        
                        return 0;
                    })      
                    /* BLOCK FOR EQUALIZE END */
                }

            },
            calculateCreatable(id, creatableFTAs, tempX, recalc, today, rosterFrom, rosterTo, rosterMonth, mapTemplate){
                let row = this.$parent.employeePlannedActual[id];

                let contracts = Object.values(this.$parent.currentMonthEmployeeContractMap).filter(item => item.employeeId == id);
                let obj = {
                    'id' : id,
                    'opened' : false,
                    'sumWorktime' : 0,
                    'sum' : 0,
                    'employeeId' : id,
                    'doFTA' : false,
                    'selectedForFTA' : true,
                    'ftsum' : 0,
                    'ftausgleich' : 0,
                    'contracts' : contracts,
                    'minutesPerWeek' : 0,
                    'maxMinutesPerWeek': 60*60,
                    'minutesPerDay' : 0,
                    'maxEqualize' : 0,
                    'remainingEqualize' : 0,
                    'dayMap' : {},
                };
                if(recalc){
                    for(let i in tempX){
                        let tmp = tempX[i];
                        if(tmp.id == id){
                            obj = tmp;
                        }
                    }
                }
                   

                for(let cId in contracts){
                    let contract = contracts[cId];
                    let cDates = this.$parent.employeeContractMomentMap[contract.id];
                    let dailyOverTimeCutoff = contract.overtimeCutoff;
                    
                    let weeklyOvertimeCutoff = contract.weeklyOvertimeCutoff
                    
                    if(cDates.toDate == null){
                        
                        if(rosterTo > cDates.fromDate){
                            
                            obj.minutesPerWeek = contract.weekTimeRegular;
                            obj.minutesPerDay = contract.weekTimeRegular / contract.weekWorkDaysRegular;
                            if(this.ftaConfigState.configUseOvertime){
                                obj.minutesPerDay = Math.max(obj.minutesPerDay, dailyOverTimeCutoff); 
                            } else if(this.ftaConfigState.configUseCustomMax){
                                obj.minutesPerDay = Math.floor(this.ftaConfigState.customMaxTime*60); 
                            }
                            let acontract = contract.collectiveContractId ? this.$parent.allowedContractMap[contract.collectiveContractId]: null;
                            let ccontract = null;
                            if(acontract != null){
                                ccontract = this.$parent.collectiveContractMap[acontract.collectiveContractId] ? this.$parent.collectiveContractMap[acontract.collectiveContractId] : null;
                            }
                            obj.maxMinutesPerWeek = ccontract != null ? ccontract.weekTimeMax : 60 *60;
                            if(this.ftaConfigState.configUseWeekOvertime){
                                obj.maxMinutesPerWeek = Math.min(obj.maxMinutesPerWeek, weeklyOvertimeCutoff);
                            }
                            
                        }
                    }else{
                        if(rosterTo > cDates.fromDate && rosterFrom < cDates.toDate){
                            
                            obj.minutesPerWeek = contract.weekTimeRegular;
                            obj.minutesPerDay = contract.weekTimeRegular / contract.weekWorkDaysRegular;
                            if(this.ftaConfigState.configUseOvertime){
                                obj.minutesPerDay = Math.max(obj.minutesPerDay, dailyOverTimeCutoff); 
                            } else if(this.ftaConfigState.configUseCustomMax){
                                obj.minutesPerDay = Math.floor(this.ftaConfigState.customMaxTime*60); 
                            }
                            let acontract = contract.collectiveContractId ? this.$parent.allowedContractMap[contract.collectiveContractId]: null;
                            let ccontract = null;
                            if(acontract != null){
                                ccontract = this.$parent.collectiveContractMap[acontract.collectiveContractId] ? this.$parent.collectiveContractMap[acontract.collectiveContractId] : null;
                            }
                            obj.maxMinutesPerWeek = ccontract != null ? ccontract.weekTimeMax : 60 *60;
                            if(this.ftaConfigState.configUseWeekOvertime){
                                obj.maxMinutesPerWeek = Math.min(obj.maxMinutesPerWeek, weeklyOvertimeCutoff);
                            }
                        }
                    }
                }
                let sumSollWorkTime = row.sollWorkTime
                if(this.ftaConfigState.configAddPositivePrevMonthWorktime && row.deltaWorkTime > 0){
                    sumSollWorkTime -= row.deltaWorkTime;
                } 
                if(this.ftaConfigState.configAddNegativePrevMonthWorktime && row.deltaWorkTime < 0){
                    sumSollWorkTime -= row.deltaWorkTime;
                }

                obj.sumWorktime = ((row.sumWorkTimeProduktiv + row.sumWorkTimeUnproduktiv - sumSollWorkTime) / 1000 / 3600 );
                obj.sum = ((sumSollWorkTime + row.sumWorkTimeProduktiv + row.sumWorkTimeUnproduktiv) / 1000 / 3600);
                   
                obj.ftsum = ( (row.deltaFtWorkTime + row.ftPlanTime + row.ftIstConfirmedTime + row.ftIstUnconfirmedTime - row.ftaTime) / 1000 / 3600);
                let wtDelta = obj.sumWorktime * -1;
                let maxEq = Math.min( wtDelta > 0 ? wtDelta : 0  , obj.ftsum +(this.ftaConfigState.additionalFTADays * obj.minutesPerDay/60))
                if(this.ftaConfigState.configAllowOverPlanWorktime){
                    maxEq = obj.ftsum +(this.ftaConfigState.additionalFTADays * obj.minutesPerDay/60);
                }

                let weekWorkDaysMap = {};
                let dayMap = {};
               
                if((obj.sumWorktime < 0 && obj.ftsum > 0) || maxEq > 0){
                    obj.maxEqualize = maxEq;
                    obj.remainingEqualize = ((row.deltaFtWorkTime + row.ftPlanTime + row.ftIstConfirmedTime + row.ftIstUnconfirmedTime - row.ftaTime)/1000/60) - (obj.maxEqualize * 60);


                    
                    
                    for(let x in mapTemplate){
                        let dayStart = this.$helpers.getMomentFromStringTZ(x);
                        
                        let dayEnd = dayStart.clone().add(1,'days');
                        dayMap[x] = {   
                            'isFree' : true, 
                            'useFTA' : 0, 
                            'formatAUT' : dayStart.format('DD. MMMM'),
                            'from' : dayStart,
                            'to' : dayEnd
                        };

                        //mark days not within contract as not free
                        let isFree = false;
                        for(let cId in contracts){
                            let cDates = this.$parent.employeeContractMomentMap[contracts[cId].id];
                            
                            if(cDates.toDate == null){
                                
                                if(dayEnd > cDates.fromDate){
                                   isFree = true;
                                }
                            }else{
                                if(dayEnd > cDates.fromDate && dayStart < cDates.toDate){
                                    isFree = true;
                                }
                            }
                            
                        }
                        
                        //mark days that are part of the spare time interval as not free, if week has no spare time interval, mark as not free
                        if(this.spareTimeMaps[id]){
                            let spareTimeMap = this.spareTimeMaps[id];
                            
                            let weekKey = dayStart.year()+"-"+dayStart.isoWeek();
                            
                            if(spareTimeMap[weekKey] && isFree){
                                isFree = !(dayStart < spareTimeMap[weekKey].to && dayEnd > spareTimeMap[weekKey].from);
                                
                            } else {
                                isFree = false;
                            }
                        } else {
                            
                            isFree = false;
                        }
                       
                        //mark days that are holidays as not free
                        if(this.$parent.storeEventMomentMap[x] && this.$parent.storeEventMomentMap[x].length > 0){
                            for (let i in this.$parent.storeEventMomentMap[x]) {
                                let event = this.$parent.storeEventMomentMap[x][i];
                                if(event.federalHoliday){
                                   isFree= false;
                                   break;
                                }
                            }
                           
                        }
                         
                        dayMap[x].isFree = isFree;

                    }
                    
                    let pShifts = (Object.values(this.$parent.planShiftMap).filter(shift => shift.employeeId == id));
                    let aShifts = (Object.values(this.$parent.actualShiftMap).filter(shift => shift.employeeId == id));
                    let shifts = pShifts.concat(aShifts);
                    let daysMarkedMap = {};
                    shifts.forEach(shift => {
                        let shiftStart = this.$helpers.getMomentFromStringTZ(shift.from);
                        let mapKey = shiftStart.format("YYYY-MM-DD");
                        let weekKey = shiftStart.isoWeek();
                        if(dayMap[mapKey]){
                            
                            dayMap[mapKey].isFree = false;
                        }
                        if(!weekWorkDaysMap[weekKey]){
                            weekWorkDaysMap[weekKey] = 0;
                        }
                        if(!daysMarkedMap[mapKey]){
                            weekWorkDaysMap[weekKey] += 1;
                            daysMarkedMap[mapKey] = true;
                        }
                        

                        if(!this.ftaConfigState.configAllowDaysWithPastMidnight){
                            let shiftEnd =      this.$helpers.getMomentFromStringTZ(shift.to);
                            mapKey = shiftEnd.format("YYYY-MM-DD");
                            if(dayMap[mapKey]){
                                
                                dayMap[mapKey].isFree = false;
                            }
                        }
                    })
                    
                    
                    let prefs = (Object.values(this.$parent.employeePreferenceMap).filter(pref => pref.employeeId == id && pref.state == 1))
                    prefs.forEach(pref => {
                        let prefMoment = this.$parent.employeePreferenceMomentMap[pref.id];
                        let prefStart = prefMoment.fromDate.clone().startOf('day');
                        while(prefStart < prefMoment.toDate){
                            let mapKey = prefStart.format("YYYY-MM-DD");
                            let weekKey = prefStart.isoWeek();
                            
                            if(dayMap[mapKey]){
                               
                                dayMap[mapKey].isFree = false;
                            }
                            if(!weekWorkDaysMap[weekKey]){
                                weekWorkDaysMap[weekKey] = 0;
                            }
                            weekWorkDaysMap[weekKey] += 1;
                            if(!daysMarkedMap[mapKey]){
                                weekWorkDaysMap[weekKey] += 1;
                                daysMarkedMap[mapKey] = true;
                            }
                            prefStart = prefStart.add(1, 'days');
                        }
                                
                    })
                    
                    obj.dayMap = dayMap;
                }

                
                let restMinutes = obj.maxEqualize * 60;
                let takenMinutes = 0;
                
                if(restMinutes > 0){
                    let rosterFrom = this.$helpers.getMomentFromStringTZ(this.$store.state.rosterFromTo.from);
                    let rosterTo = this.$helpers.getMomentFromStringTZ(this.$store.state.rosterFromTo.to);
                        
                    let starterWeek = rosterFrom.clone();
                    for(let i = starterWeek; i < rosterTo && restMinutes > 0; i = i.add(1,'weeks')){
                        let y = i;

                        let weekKey = i.isoWeek();
                        let weekWorkDays = weekWorkDaysMap[weekKey] ? weekWorkDaysMap[weekKey] : 0;
                        let weekWorkValue = this.weekWorkTimeMaps[id] ? (this.weekWorkTimeMaps[id][weekKey] ? Math.round(this.weekWorkTimeMaps[id][weekKey].combinedWorkTime/60) : 0) : 0;
                        
                        
                        
                        let freeDays = 0;
                        for(let j = 0; j < 7; j++){
                            let z = y.clone().add(j,'days');
                            
                            if(obj.dayMap[z.format('YYYY-MM-DD')] && obj.dayMap[z.format('YYYY-MM-DD')].isFree && weekWorkDays < this.ftaConfigState.maxWorkDays){
                                if( (this.ftaConfigState.configCreateTimeframe == 0 && z > today && z.month() == rosterMonth.month()) || 
                                    (this.ftaConfigState.configCreateTimeframe == 1 && z.month() == rosterMonth.month())){
                                    freeDays++;
                                }
                            }
                        }
                       

                        let possibleDays = freeDays;
                        
                        if(possibleDays >= 1 && restMinutes > 0){
                            //console.log("TRY TO TAKE");
                            for(let j = 0; j < 7; j++){
                                let z = y.clone().add(j,'days');
                               
                                if(restMinutes > 0 && obj.dayMap[z.format('YYYY-MM-DD')] && obj.dayMap[z.format('YYYY-MM-DD')].isFree && obj.selectedForFTA && weekWorkDays < this.ftaConfigState.maxWorkDays){
                                        //console.log("TAKE IT");
                                    if( (this.ftaConfigState.configCreateTimeframe == 0 && z > today && z.month() == rosterMonth.month()) || 
                                         (this.ftaConfigState.configCreateTimeframe == 1 && z.month() == rosterMonth.month())){
                                        
                                        let remainingWeekWorktime = Math.max(0, obj.maxMinutesPerWeek - weekWorkValue);
                                        if(remainingWeekWorktime > 0){
                                            let ftaWorkTime = Math.min(remainingWeekWorktime, Math.min(restMinutes,obj.minutesPerDay));
                                            obj.doFTA = true;
                                            obj.dayMap[z.format('YYYY-MM-DD')].useFTA = ftaWorkTime;
                                            restMinutes = restMinutes - ftaWorkTime;
                                            takenMinutes += ftaWorkTime;
                                            weekWorkValue += ftaWorkTime;
                                            weekWorkDays +=1;
                                                //obj.remainingEqualize = restMinutes;
                                            
                                        }
                                        
                                    }
                                }
                                //console.log("REST MINUTES: " + restMinutes);
                            }
                        }
                    }
                }
                obj.remainingEqualize = ((row.deltaFtWorkTime + row.ftPlanTime + row.ftIstConfirmedTime + row.ftIstUnconfirmedTime - row.ftaTime)/1000/60) - takenMinutes;
                    
                creatableFTAs.push(obj);
            },
            calculateDeletable(id, deletableFTAs, tempY, recalc, today, rosterMonth){
                let obj2 = {
                    'id' : id,
                    'opened' : false,
                    'employeeId' : id,
                    'deleteFTA': false,
                    'selectedForFTA' : true,
                    'map' : {},
                    'items': 0,
                    'itemLabel': this.$tc('roster.comp.entry')
                };
                if(recalc){
                    for(let i in tempY){
                        let tmp = tempY[i];
                        if(tmp.id == id){
                            obj2 = tmp;
                            obj2.items = 0;
                            obj2.itemLabel = this.$tc('roster.comp.entry', 2);
                        }
                    }
                }
                let map = {};
                let contracts = Object.values(this.$parent.currentMonthEmployeeContractMap).filter(item => item.employeeId == id);

                


                if(this.$parent.employeePreferenceAvailabilityMap[id] && this.$parent.employeePreferenceAvailabilityMap[id].preferences.length > 0){
                    for(let p1 in this.$parent.employeePreferenceAvailabilityMap[id].preferences){
                        let p = this.$parent.employeePreferenceAvailabilityMap[id].preferences[p1];
                        let itemdate = this.$parent.employeePreferenceMomentMap[p.id];
                            
                        if(p.type == 3){
                            if( (this.ftaConfigState.configSelectionTimeframe == 0 && itemdate.fromDate > today && itemdate.fromDate.month() == rosterMonth.month()) || 
                                (this.ftaConfigState.configSelectionTimeframe == 1 && itemdate.fromDate.month() == rosterMonth.month())){


                                let cMPD = 0;
                                for(let cId in contracts){
                                    let cDates = this.$parent.employeeContractMomentMap[contracts[cId].id];
                                    if(cDates.toDate == null){
                                        if(itemdate.fromDate >= cDates.fromDate){
                                            cMPD = contracts[cId].weekTimeRegular / contracts[cId].weekWorkDaysRegular;
                                        }
                                    }else{
                                        if(itemdate.fromDate >= cDates.fromDate && itemdate.fromDate < cDates.toDate){
                                            cMPD = contracts[cId].weekTimeRegular / contracts[cId].weekWorkDaysRegular;
                                        }
                                    }
                                }

                                obj2.deleteFTA = true;
                                   
                                let workValue = p.workValue;
                                if(p.workValue == -1){
                                    workValue = Math.min(cMPD,(itemdate.toDate - itemdate.fromDate) / 1000 / 60);
                                }
                                map[p.id] = {'item':p, 'dates':itemdate, 'workValue':workValue};

                                obj2.items++;
                                
                                if(obj2.items == 1){
                                    obj2.itemLabel = this.$tc('roster.comp.entry');
                                }
                                if(obj2.items > 1){
                                    obj2.itemLabel = this.$tc('roster.comp.entry', 2);
                                }
                                    
                            }
                        }
                    }
                }
                obj2.map = map;
                deletableFTAs.push(obj2);
            },
            calculateEqualizable(id, equalizableFTAs, tempZ, recalc, today, rosterMonth){
                let row = this.$parent.employeePlannedActual[id];
                let contracts = Object.values(this.$parent.currentMonthEmployeeContractMap).filter(item => item.employeeId == id);
                let obj = {
                    id : id,
                    opened : false,
                    employeeId : id,
                    equalizeFTA: false,
                    selectedForFTA : true,
                    map : {},
                    items: 0,
                    itemLabel: this.$tc('roster.comp.entry'),
                    sumWorktime: 0,
                    ftsum: 0,
                    maxEqualize: 0,
                    remainingEqualize: 0,
                };
                let sumSollWorkTime = row.sollWorkTime
                if(this.ftaConfigState.configAddPositivePrevMonthWorktime && row.deltaWorkTime > 0){
                    sumSollWorkTime -= row.deltaWorkTime;
                } 
                if(this.ftaConfigState.configAddNegativePrevMonthWorktime && row.deltaWorkTime < 0){
                    sumSollWorkTime -= row.deltaWorkTime;
                }
                obj.sumWorktime = ((row.sumWorkTimeProduktiv + row.sumWorkTimeUnproduktiv - sumSollWorkTime) / 1000 / 3600 );  
                obj.ftsum = ( (row.deltaFtWorkTime + row.ftPlanTime + row.ftIstConfirmedTime + row.ftIstUnconfirmedTime - row.ftaTime) / 1000 / 3600);


                if(recalc){
                    for(let i in tempZ){
                        let tmp = tempZ[i];
                        if(tmp.id == id){
                            obj = tmp;
                            obj.items = 0;
                            obj.itemLabel = this.$tc('roster.comp.entry', 2);
                        }
                    }
                }
                let map = {};
                
                let wtDelta = obj.sumWorktime * -1;

                let maxEq =  Math.min(wtDelta  , obj.ftsum )
                if(this.ftaConfigState.configAllowOverPlanWorktime){
                    maxEq = obj.ftsum;
                }
                
                if((obj.sumWorktime < 0 && obj.ftsum > 0 ) || obj.ftsum < 0 || maxEq != 0){
                    let sumWorkTimeWithoutFTA = (row.sumWorkTimeProduktiv + (row.sumWorkTimeUnproduktiv - row.ftaTime) - row.sumSollWorkTime)/ 1000 / 3600
                    let ftSumWithoutFTA = (row.deltaFtWorkTime + row.ftPlanTime + row.ftIstConfirmedTime + row.ftIstUnconfirmedTime )/ 1000 / 3600
                    

                    obj.maxEqualize =  this.ftaConfigState.configAllowOverPlanWorktime ? ftSumWithoutFTA : Math.min(Math.max(0, -1* sumWorkTimeWithoutFTA), ftSumWithoutFTA);
                    
                    obj.remainingEqualize = maxEq * 60 //((row.deltaFtWorkTime + row.ftPlanTime + row.ftIstConfirmedTime + row.ftIstUnconfirmedTime - row.ftaTime)/1000/60) - (obj.maxEqualize * 60);
                    let totalFtaTime = obj.ftsum *60;
                    
                    if(this.$parent.employeePreferenceAvailabilityMap[id] && this.$parent.employeePreferenceAvailabilityMap[id].preferences.length > 0){
                        let ftaEntries = [];
                        let cMPD = 0;
                        let cRWV = 0;

                        for(let p1 in this.$parent.employeePreferenceAvailabilityMap[id].preferences){
                            let p = this.$parent.employeePreferenceAvailabilityMap[id].preferences[p1];
                            let itemdate = this.$parent.employeePreferenceMomentMap[p.id];
                            for(let cId in contracts){
                                let cDates = this.$parent.employeeContractMomentMap[contracts[cId].id];
                                if(cDates.toDate == null){
                                    if(itemdate.fromDate >= cDates.fromDate){
                                        cMPD = contracts[cId].weekTimeRegular / contracts[cId].weekWorkDaysRegular;
                                        cRWV = cMPD;
                                        if(this.ftaConfigState.configUseOvertime){
                                            cMPD = Math.max(cMPD, contracts[cId].overtimeCutoff); 
                                        } else if(this.ftaConfigState.configUseCustomMax){
                                            cMPD = Math.floor(this.ftaConfigState.customMaxTime*60); 
                                        }
                                    }
                                }else{
                                    if(itemdate.fromDate >= cDates.fromDate && itemdate.fromDate < cDates.toDate){
                                        cMPD = contracts[cId].weekTimeRegular / contracts[cId].weekWorkDaysRegular;
                                        cRWV = cMPD;
                                        if(this.ftaConfigState.configUseOvertime){
                                            cMPD = Math.max(cMPD, contracts[cId].overtimeCutoff); 
                                        } else if(this.ftaConfigState.configUseCustomMax){
                                            cMPD = Math.floor(this.ftaConfigState.customMaxTime*60); 
                                        }
                                    }
                                }
                            }
                            
                            if(p.type == 3){
                                if( (this.ftaConfigState.configSelectionTimeframe == 0 && itemdate.fromDate > today && itemdate.fromDate.month() == rosterMonth.month()) || 
                                    (this.ftaConfigState.configSelectionTimeframe == 1 && itemdate.fromDate.month() == rosterMonth.month())){


                                    let workValue = p.workValue;
                                    if(p.workValue == -1){
                                        workValue = Math.min(cRWV,(itemdate.toDate - itemdate.fromDate) / 1000 / 60);
                                    }
                                    ftaEntries.push({'item':p, 'dates':itemdate, 'workValue':workValue, newWorkValue: workValue});    
                                }
                            }
                        }
                        ftaEntries.sort((a, b) => {
                            return a.dates.fromDate - b.dates.fromDate;
                        })
                        ftaEntries.forEach(entry => {
                            let nWV = Math.max(0, Math.min(Math.max(entry.workValue, cMPD), entry.workValue + obj.remainingEqualize))
                            let delta = entry.workValue - nWV;
                            
                            if(delta != 0){
                                map[entry.item.id] = entry;
                                obj.remainingEqualize = obj.remainingEqualize + delta;
                                totalFtaTime = totalFtaTime + delta;
                                entry.newWorkValue = nWV;
                                obj.items++;
                            }
                            
                        })
                        obj.remainingEqualize = totalFtaTime;
                        if(obj.items == 1){
                            obj.itemLabel = this.$tc('roster.comp.entry');
                        }
                        if(obj.items > 1){
                            obj.itemLabel = this.$tc('roster.comp.entry', 2);
                        }
                        if(obj.items > 0){
                            obj.equalizeFTA = true;
                        }

                                    
                                    
                                    
                    }
                }
                obj.map = map;
                equalizableFTAs.push(obj);
            },
            Close(){
                //if($(window.mouse.element).closest('.fta').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    view.posx = Math.max(0,($(window).width()/2) - (850/2));//box.left + box.width + 5;
                    view.posy = 55 //box.top;
                    view.$forceUpdate();
                });
            },
        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .configSelectorGreen{
        padding-left: 10px; 
        padding-right: 10px; 
        border-radius: 20px; 
        display:inline-block; 
        height: 16px; 
        line-height: 16px; 
        font-size: 11px; 
        background-color:#6d8d23; 
        color:#fff; 
        width: 150px; 
        margin-right: 10px;
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }

    .configSelectorGray{
        padding-left: 10px; 
        padding-right: 10px; 
        border-radius: 20px; 
        display:inline-block; 
        height: 16px; 
        line-height: 16px; 
        font-size: 11px; 
        background-color:#ccc; 
        color:#fff; 
        width: 150px;
        margin-right: 10px;
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }


    .boxPanelLeftSelected{
        display: inline-block;
        width:266px;
        overflow: hidden;
        height: 30px;
        margin-left: 10px; 
        padding: 5px; 
        border-left: 1px solid darkslategray; 
        border-top: 1px solid darkslategray; 
        border-right: 1px solid darkslategray;
        text-align: center;
        background-color: #f5f5f5;
    }
    .boxPanelLeftNotSelected{
        display: inline-block;
        width:266px;
        overflow: hidden;
        height: 30px;
        margin-left: 10px; 
        padding: 5px; 
        border-bottom: 1px solid darkslategray; 
        text-align: center;
        background-color: #fff;
    }

    .boxPanelMiddleSelected{
        display: inline-block;
        width:266px;
        overflow: hidden;
        height: 30px;
        /*margin-left: 10px; */
        padding: 5px; 
        border-left: 1px solid darkslategray; 
        border-top: 1px solid darkslategray; 
        border-right: 1px solid darkslategray;
        text-align: center;
        background-color: #f5f5f5;
    }
    .boxPanelMiddleNotSelected{
        display: inline-block;
        width:266px;
        overflow: hidden;
        height: 30px;
        /*margin-left: 10px; */
        padding: 5px; 
        border-bottom: 1px solid darkslategray; 
        text-align: center;
        background-color: #fff;
    }



    .boxPanelRightSelected{
        display: inline-block;
        width:266px;

        overflow: hidden;
        height: 30px;
        margin-right: 0px; 
        padding: 5px; 
        border-left: 1px solid darkslategray; 
        border-top: 1px solid darkslategray; 
        border-right: 1px solid darkslategray;
        text-align: center;
        background-color: #f5f5f5;
    }
    .boxPanelRightNotSelected{
        display: inline-block;
        width:266px;

        overflow: hidden;
        height: 30px;
        margin-right: 0px; 
        padding: 5px; 
        border-bottom: 1px solid darkslategray; 
        text-align: center;
    }

    .panelContent{
        overflow-x: hidden;
        overflow-y: scroll; 
        min-height: 200px; 
        max-height: 400px; 
        margin-left: 10px; 
        margin-right: 10px; 
        margin-top:-3px;
        padding: 25px; 
        border-left: 1px solid darkslategray;
        border-bottom: 1px solid darkslategray;
        border-right: 1px solid darkslategray;
        background-color: #f5f5f5;
    }

    .fta{
        position:fixed;
        display:inline-block;
        width: 850px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 15px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
        overflow-x: hidden;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

    .picture{
        border-radius: 100px;
        margin-right:10px;
        width: 25px;
        height: 25px;
    }

    .updown{
        color: #e5e5e5; 
        background-color: #555555;
        font-size: 20px;
        border-radius: 20px;;
    }

    .updown :hover{
        color: #555 !important; 
        background-color: #fff !important; 
    }


</style>
